import { queryOptions, skipToken } from "@tanstack/react-query";

import { api } from "@/api/api";
import type {
  GetFlightUpsellBodyInputDto,
  GetFlightUpsellOutputDto,
} from "@/types/codegen";

type FlightUpsellParams = {
  index: string;
  body: GetFlightUpsellBodyInputDto;
};

export const flightUpsellQueryOptions = (params: FlightUpsellParams | null) =>
  queryOptions({
    queryKey: ["flight-upsell", params] as const,
    queryFn: params
      ? ({ signal }) =>
          api.post<GetFlightUpsellOutputDto>(
            `/flights/${params.index}/upsell`,
            params.body,
            { signal },
          )
      : skipToken,
    select: (data) => data.data.data,
  });
